export enum LanguageCode {
    en = 'en',
    ru = 'ru',
    zh = 'zh',
}

export const SUPPORTED_LANGUAGES: ReadonlySet<string> = new Set(
  Object.values(LanguageCode),
);

export const DEFAULT_LANGUAGE: string = LanguageCode.en;
